import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import { verifyCerti } from '../../api/apiHandler';
import moment from 'moment';
import { Loading } from '../../components/loading/loading';

const VerifyCertificate = () => {
    const [searchParams] = useSearchParams();
    const certificateNo = searchParams.get("certificate");
    const [verificationData, setVerificationData] = useState([]);
    const [isVerified, setIsVerified] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        verifyCertificate();
    }, [])

    const verifyCertificate = async () => {
        const response = await verifyCerti({ certificate_no: certificateNo })
        if (response.code == 200) {
            setIsVerified(true);
            setVerificationData(response.data);
        }
        setIsLoading(false);
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }
    return (
        <>
            <div className=' pd-top-120'>
                {isVerified ? (
                    <div className="bg-white pt-5 rounded shadow-md text-center max-w-md" style={{ height: '50vh' }}>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/img/logo-new.svg"}
                            alt="Website Logo"
                            width={'150px'}
                        />
                        <h2 className="text-xl font-semibold mb-2 mt-4">
                            {verificationData?.enroll_user?.full_name}
                        </h2>

                        <p className="mb-2">has successfully completed the course</p>
                        <h3 className="text-lg font-medium mb-2 mt-4">
                            {verificationData?.user_course?.name}
                        </h3>

                        <p className="text-gray-600">on {moment(verificationData?.completion_date).format("MMMM Do, YYYY")}</p>
                    </div>
                ) : (
                    <h2 className="font-semibold mb-2 mt-4 text-center">Unverified</h2>
                )}
            </div>
        </>
    )
}

export default VerifyCertificate;